import { DialogComponent } from '@theme/dialog';

/**
 * A sold-out "Notify me" trigger + dialog. Extends the shared dialog
 * primitive only to auto-reopen (as a real modal, via showDialog/showModal
 * rather than the raw `open` attribute) after a full-page form submit
 * left the server-rendered dialog with a success or error message.
 *
 * @extends DialogComponent
 */
class NotifyMeDialog extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    if (this.refs.dialog?.hasAttribute('data-open-on-load')) {
      this.showDialog();
    }
  }
}

if (!customElements.get('notify-me-dialog')) {
  customElements.define('notify-me-dialog', NotifyMeDialog);
}
